import { useState, useEffect } from "react";
import BASE_URL from "../../BASEURL";

export default function Payments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/orders`);
      const data = await res.json();
      if (data.success && data.orders) {
        // Map orders to a payment structure
        const mappedPayments = data.orders.map((order) => ({
          id: order._id,
          orderId: order._id.substring(order._id.length - 8).toUpperCase(),
          user: order.userId ? order.userId.name : "Guest User",
          amount: order.totalPrice,
          method: order.paymentMethod === "ONLINE" ? "Online (Razorpay)" : "Cash on Delivery",
          status: order.paymentStatus ? order.paymentStatus.charAt(0).toUpperCase() + order.paymentStatus.slice(1) : "Pending",
        }));
        setPayments(mappedPayments);
      }
    } catch (error) {
      console.error("Error fetching payments:", error);
    } finally {
      setLoading(false);
    }
  };

  const statusBadge = (status) => {
    switch (status) {
      case "Paid":
      case "Success":
        return "bg-green-100 text-green-700";
      case "Pending":
        return "bg-yellow-100 text-yellow-700";
      case "Failed":
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  if (loading) {
    return <div className="p-6">Loading payments...</div>;
  }

  return (
    <>
      {/* PAGE TITLE */}
      <h2 className="text-2xl font-heading font-bold mb-6 text-primary">
        Payments
      </h2>

      {/* PAYMENTS TABLE */}
      <div className="bg-white rounded shadow overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-primary/70 text-light">
            <tr>
              <th className="p-3 text-left">Order ID</th>
              <th className="p-3 text-left">User</th>
              <th className="p-3 text-left">Amount</th>
              <th className="p-3 text-left">Method</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>

          <tbody>
            {payments.map((payment) => (
              <tr key={payment.id} className="border-t hover:bg-gray-50">
                <td className="p-3 font-semibold">
                  {payment.orderId}
                </td>
                <td className="p-3">{payment.user}</td>
                <td className="p-3 font-semibold">
                  ₹{payment.amount}
                </td>
                <td className="p-3">{payment.method}</td>
                <td className="p-3">
                  <span
                    className={`px-3 py-1 rounded text-xs font-semibold ${statusBadge(
                      payment.status
                    )}`}
                  >
                    {payment.status}
                  </span>
                </td>
              </tr>
            ))}
            {payments.length === 0 && (
              <tr>
                <td colSpan="5" className="p-4 text-center text-gray-500">
                  No payment/transactions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
